import * as t from 'io-ts';

export function optional<RT extends t.Any>(type: RT) {
  return t.union([type, t.null, t.undefined]);
}
